"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttribute = getAttribute;
exports.getAndStripAttribute = getAndStripAttribute;
function getAttribute(name, domContainer) {
    return domContainer.getAttribute(name);
}
function getAndStripAttribute(name, domContainer) {
    const value = getAttribute(name, domContainer);
    if (window.location.host.includes("www")) {
        domContainer.removeAttribute(name);
    }
    else {
        console.log(`data for element id: ${domContainer.id} with classes: ${domContainer.className} attribute: ${name} is: ${value}`);
    }
    return value;
}
